import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FieldConfigName} from '../../../../models';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {Constants} from '../../../common/constants';
import {DmConfirmDialogComponent} from '../../../shared/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-field-label-required-actions',
  templateUrl: './label-required-component-actions.component.html',
  styleUrls: ['./label-required-component-actions.component.scss']
})
export class LabelRequiredComponentActionsComponent implements OnInit {
  _control: FieldConfigName;
  @Input() set control(value: FieldConfigName) {
    this._control = value;
    this.initFormAndSet();
  }
  get control() {
    return this._control;
  }
  @Input() indexControl: number;
  @Input() dialogComponent;
  @Input() hideRequieredButton: boolean;
  @Output() updateField = new EventEmitter<{ control: FieldConfigName, index: number }>();
  @Output() deleteField = new EventEmitter<number>();
  controlForm: UntypedFormGroup;
  minLengthLabel: number;
  maxLengthLabel: number;
  constants: any = Constants;
  constructor(private formBuilder: UntypedFormBuilder,
              public dialog: MatDialog) {
  }

  ngOnInit(): void {
    this.minLengthLabel = this.constants.sizeLabelField.minLengthLabel;
    this.maxLengthLabel = this.constants.sizeLabelField.maxLengthLabel;
  }
  optionsActions(ev, control: FieldConfigName, indexControl: number) {
    if (ev === 'edit') {
      this.editFieldDialog(this.dialogComponent, control, indexControl);
    }
    if (ev === 'delete') {
      this.deleteFieldDialog(control, indexControl);
    }
  }

  /**
   * Editions des options du champ
   * @param dialogComponent
   * @param {FieldConfigName} control
   * @param {number} indexControl
   * @protected
   */
  protected editFieldDialog(dialogComponent, control: FieldConfigName, indexControl: number): void {
    const dialogRef = this.dialog.open(dialogComponent, {
      disableClose: true,
      width: '744px',
      data: {
        control,
        buttonText: {
          ok: 'Fermer',
          cancel: 'Annuler'
        },
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        const objControl = {
          position: indexControl + 1,
          id: control.id,
          defaultFieldId: control.defaultFieldId,
          options: {...control.options, ...result}
        };
        this.emitChangedParent(objControl, indexControl);
      }
    });
  }

  /**
   * Suppression du champ
   * @param control
   * @param indexControl
   * @protected
   */
  protected deleteFieldDialog(control: FieldConfigName, indexControl: number): void {
    const dialogRef = this.dialog.open(DmConfirmDialogComponent, {
      width: '350px',
      data: {control, message: this.constants.messages.waringMessage}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        this.emitDeletedParent(indexControl);
      }
    });
  }
  /**
   * Init form, valeurs existantes, écoute des changements
   * @private
   */
  protected initFormAndSet() {
    this.controlForm = this.formBuilder.group({
      label: ['', [
        Validators.required,
        Validators.minLength(this.minLengthLabel), Validators.maxLength(this.maxLengthLabel)]],
      isRequired: [false]
    });
    this.controlForm.patchValue({
      label: this.control.options.label,
      isRequired: this.control.options.isRequired
    });
    this.controlForm.valueChanges.subscribe(_values => {
      this.control.options.label = _values.label;
      this.control.options.isRequired = _values.isRequired;
      this.emitChangedParent(this.control, null);
    });
  }
  emitChangedParent(control, indexControl: number) {
    this.updateField.emit({control: control, index: indexControl !== null ? indexControl : this.indexControl});
  }

  emitDeletedParent(indexControl: number) {
    this.deleteField.emit(indexControl);
  }
}
